<template>
  <ion-list v-if="resources != null">
    <ion-item
      v-for="item in resources.data"
      :key="item.id"
      :ref="`items-${item.id}`"
      class="hydrated link"
    >
      <ion-label @click="openPopover(item, $event)">
        <h2>{{ item.name }}</h2>
      </ion-label>
    </ion-item>
  </ion-list>
  <ion-list v-else>
    <ion-list-header>
      <p>No Chargeables found</p>
    </ion-list-header>
  </ion-list>
  <ion-modal
    :is-open="updateModalState"
    @didDismiss="setUpdateModalState(false)"
  >
    <base-modal
      title="Update chargeable"
      @closeModal="setUpdateModalState(false)"
    >
      <update-chargeable
        @closeModal="setUpdateModalState(false)"
        :resource="resourceToUpdate"
      ></update-chargeable>
    </base-modal>
  </ion-modal>
  <ion-popover
    :is-open="popoverState"
    :event="popoverEvent"
    @didDismiss="setPopoverState(false)"
  >
    <base-popover
      @closePopover="setPopoverState(false)"
      :title="selectedResource.name"
    >
      <ion-item
        button
        @click="setPopoverState(false)"
        :router-link="{
          name: 'chargeable.student',
          params: {
            chargeable: selectedResource.id,
            title: `${selectedResource.name}`,
          },
        }"
        >Students</ion-item
      >
      <ion-item button @click="setResourceToUpdate(selectedResource.id)"
        >Edit</ion-item
      >
      <ion-item
        button
        @click="
          confirmDelete({
            id: selectedResource.id,
            name: selectedResource.name,
          })
        "
        >Delete</ion-item
      >
    </base-popover>
  </ion-popover>
</template>
<script>
import BaseModal from "../../../Base/BaseModal";
import UpdateChargeable from "../Chargeable/UpdateChargeable";
import BasePopover from "../../../Base/BasePopover";
import {
  IonList,
  IonListHeader,
  IonLabel,
  IonItem,
  IonModal,
  IonPopover,
  alertController,
} from "@ionic/vue";

export default {
  props: {
    resources: {
      type: Object,
      required: true,
    },
  },

  components: {
    IonList,
    IonListHeader,
    IonLabel,
    IonItem,
    IonModal,
    IonPopover,
    BaseModal,
    BasePopover,
    UpdateChargeable,
  },
  data() {
    return {
      updateModalState: false,

      popoverState: false,
      popoverEvent: null,
      selectedResource: null,

      resourceToUpdate: {
        id: null,
        name: null,
      },

      xhrError: {
        header: null,
        description: null,
      },
    };
  },
  methods: {
    slide(id) {
      this.$refs[`items-${id}`].$el.open();
    },

    alerter(header, message, buttons = ["close"]) {
      const alert = alertController.create({
        header: header,
        message: message,
        buttons: buttons,
      });

      return alert;
    },

    setErrorResponse(error) {
      if (error.response) {
        this.xhrError.header = error.response.data.header;
        this.xhrError.message = error.response.data.message;
      } else if (error.request) {
        this.xhrError.header = error.message || error.request;
        this.xhrError.message = "Please check your connection and try again";
      } else {
        this.xhrError.header = error.message;
        this.xhrError.message = "Something went wrong. Try again later";
      }
    },

    async confirmDelete(resource) {
      this.setPopoverState(false);
      const header = `Delete chargeable ${resource.name} ?`;
      const message = "This action cannot be undone.";
      const buttons = [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
        },
        {
          text: "Okay",
          handler: () => {
            this.delete(resource.id);
          },
        },
      ];
      const alertDialog = await this.alerter(header, message, buttons);

      alertDialog.present();
    },

    async delete(data) {
      try {
        await this.$store.dispatch("chargeable/deleteResource", data);
      } catch (error) {
        this.setErrorResponse(error);
        const alertDialog = await this.alerter(
          this.xhrError.header,
          this.xhrError.message
        );
        alertDialog.present();
      }
    },

    setUpdateModalState(state) {
      this.updateModalState = state;
      if (state == false) {
        this.setPopoverState(false);
      }
    },

    setResourceToUpdate(id) {
      const resource = this.resources.data.find(
        (resource) => resource.id === id
      );
      this.resourceToUpdate = resource;
      this.setUpdateModalState(true);
    },

    openPopover(resource, ev) {
      this.popoverEvent = ev;
      this.setSelectedResource(resource);
      this.setPopoverState(true);
    },

    setPopoverState(state) {
      this.popoverState = state;
    },

    setSelectedResource(resource) {
      this.selectedResource = resource;
    },
  },
};
</script>
